<button class="btn btn-circle btn-primary fixed bottom-6 right-6 shadow-lg z-50"
        (click)="scrollToTop()">
  <span class="material-icons-outlined">arrow_upward</span>
</button>
